<template>
    <b-modal v-model="show" title="КОД ПЛАТЕЖА">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.code"
                                :class="{'is-invalid': $v.data.code.$error}"
                                @blur="$v.data.code.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.code.$error">{{$t("realEstate.validation.cadastreSectionEdit.code")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreSectionEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label for="description">Изох </label>
                        <textarea id="description" class="form-control" v-model="data.description"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'
    export default {
        name: "PaymentCodeEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: {
                    id: null,
                    code: '',
                    name: '',
                    description: '',
                }
            }
        },
        validations: {
            data:{
                code:{
                    required
                },
                name:{
                    required
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('payment-code/save', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('paymentCodeChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showPaymentCodeEditModal', (data) => {
                if (data) {
                    this.data = clone(data);
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>